import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Vérifiez si l'utilisateur est connecté
  const isAuthenticated = localStorage.getItem('isAuthenticated'); // ou utilisez un contexte/state global

  if (!isAuthenticated) {
    // Si l'utilisateur n'est pas connecté, redirigez-le vers la page de connexion
    return <Navigate to="/loginadmin" replace />;
  }

  // Si l'utilisateur est connecté, rendez le composant demandé
  return children;
};

export default ProtectedRoute;